import { MapTo, Model } from 'src/app/decorators/mapto';

export class ServiceAreaModel extends Model {
    @MapTo()
    id: string;
    @MapTo()
    organization_id: string;
    @MapTo()
    name: string;
    @MapTo()
    main: number;
    @MapTo()
    status: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
